<template>
  <section class="locked-metric-panel">
    <page-sub-header :title="productData.title" class="mt-4">
      <template #extra-title>
        <font-awesome-icon :icon="['fas', 'lock']" class="locked-metric-panel__lock-icon" />
      </template>
    </page-sub-header>
    <sme-card class="locked-metric-panel__card">
      <div class="locked-metric-panel__content">
        <div class="locked-metric-panel__header">
          <p class="locked-metric-panel__tagline">{{ productData.tagline }}</p>
          <p class="locked-metric-panel__value-prop">{{ productData.valueProposition }}</p>
        </div>

        <div class="locked-metric-panel__stats">
          <div v-for="(item, index) in productData.industryStats" :key="index" class="locked-metric-panel__stat">
            <span class="locked-metric-panel__stat-value">{{ item.stat }}</span>
            <span class="locked-metric-panel__stat-description">{{ item.description }}</span>
          </div>
        </div>

        <div class="locked-metric-panel__cta">
          <font-awesome-icon :icon="['fas', 'circle-info']" class="locked-metric-panel__cta-icon" />
          <p class="locked-metric-panel__cta-text">
            This product is not currently live for your organisation. Reach out to your Customer Success Manager to turn
            this on.
          </p>
        </div>
      </div>
    </sme-card>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import PageSubHeader from '@/components/PageSubHeader.vue';
import SmeCard from '@/components/atoms/SmeCard.vue';
import { LOCKED_PRODUCT_DATA } from '@/config/lockedProductData';

const props = defineProps({
  productKey: {
    type: String,
    required: true,
    validator: value => Object.keys(LOCKED_PRODUCT_DATA).includes(value),
  },
});

const productData = computed(() => LOCKED_PRODUCT_DATA[props.productKey]);
</script>

<style lang="scss" scoped>
.locked-metric-panel__lock-icon {
  margin-left: 0.5rem;
  font-size: 0.75em;
  color: var(--palette-color-default-lighten-40);
}

.locked-metric-panel__card {
  background-color: var(--palette-color-base-white);
}

.locked-metric-panel__content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.locked-metric-panel__header {
  text-align: center;
  opacity: 0.6;
}

.locked-metric-panel__tagline {
  font-size: 1rem;
  font-weight: 600;
  color: var(--palette-color-default-lighten-20);
  margin-bottom: 0.5rem;
}

.locked-metric-panel__value-prop {
  font-size: 0.875rem;
  color: var(--palette-color-default-lighten-40);
  margin: 0;
}

.locked-metric-panel__stats {
  display: flex;
  justify-content: center;
  gap: 3rem;
  flex-wrap: wrap;
  opacity: 0.6;
}

.locked-metric-panel__stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.locked-metric-panel__stat-value {
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--palette-color-brand-primary);
}

.locked-metric-panel__stat-description {
  font-size: 0.75rem;
  color: var(--palette-color-default-lighten-40);
  max-width: 12rem;
}

.locked-metric-panel__cta {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem;
  background-color: var(--palette-color-core-1-lighten-90);
  border-radius: 5px;
}

.locked-metric-panel__cta-icon {
  color: var(--palette-color-brand-primary);
  font-size: 1.25rem;
  flex-shrink: 0;
  margin-top: 0.125rem;
}

.locked-metric-panel__cta-text {
  margin: 0;
  font-size: 0.875rem;
  color: var(--palette-color-default-lighten-20);
}
</style>
